export const CSR_COUNTRY_FIELD = 'country';
export const CSR_STATE_FIELD = 'state';
export const CSR_CITY_FIELD = 'city';
export const CSR_ORG_FIELD = 'organizationName';
export const CSR_ORG_UNIT_FIELD = 'organizationalUnit';
export const CSR_EMAIL_FIELD = 'email';

export const CSR_DEFAULT_VALUES = {
    exists: false,
    [CSR_COUNTRY_FIELD]: '',
    [CSR_STATE_FIELD]: '',
    [CSR_CITY_FIELD]: '',
    [CSR_ORG_FIELD]: '',
    [CSR_ORG_UNIT_FIELD]: '',
    [CSR_EMAIL_FIELD]: '',
};
